import { useLingui } from '@lingui/react/macro';
import { Seo } from './seo';

/**
 * The head of every live 404 — the portal 404, its portal-less-subdomain fallback, and the landing's.
 *
 * Its own module rather than a few lines inside `not-found.tsx` so it can be rendered on its own: that
 * file's `Footer` pulls the whole legal-content graph in behind it, which the unit test guarding this
 * title cannot load.
 *
 * The message is the redesign's, character for character (`new/-components/not-found.tsx`), so both
 * 404s share one Lingui id and one set of translations.
 */
export function NotFoundSeo() {
	const { t } = useLingui();
	// No canonical and no hreflang: there is no page at this URL to point anywhere. The HTTP 404 says
	// so too, but a crawler that ignores the status still must not index this.
	return <Seo title={t`Page not found - Worldcoo`} noindex />;
}
